const FOUNDER_IMG =
  "https://customer-assets.emergentagent.com/job_accommodation-profit/artifacts/nnwsjx6d_IMG_4529.png";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-36 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="relative aspect-[4/5] w-full overflow-hidden bg-[#0A0D10]">
            <img
              src={FOUNDER_IMG}
              alt="Aaron — founder of Black Rock Hospitality"
              className="w-full h-full object-cover object-[80%_center] grayscale hover:grayscale-0 transition-all duration-700"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#050505] to-transparent h-1/3" />
          </div>
          <div className="mt-6 flex items-center gap-3 text-xs tracking-[0.2em] uppercase text-white/50">
            <span className="block w-6 h-px bg-[#C2A878]" />
            Aaron · Founder
          </div>
        </div>

        <div className="lg:col-span-7 lg:pl-8">
          <div className="flex items-center gap-3 mb-8">
            <span className="block w-10 h-px bg-[#C2A878]" />
            <span className="text-xs tracking-[0.3em] uppercase text-[#C2A878] font-semibold">
              The Practice
            </span>
          </div>
          <h2
            data-testid="about-heading"
            className="font-serif font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-white tracking-tight"
          >
            Built by an operator.{" "}
            <em className="text-[#C2A878] not-italic">Not a coach.</em>
          </h2>

          <div className="mt-10 space-y-6 text-white/70 leading-relaxed max-w-2xl text-base md:text-lg">
            <p>
              Black Rock Hospitality was founded on the premise that most
              accommodation businesses don&apos;t have a marketing problem — they
              have a <span className="text-white">systems</span> problem. Pricing
              left on autopilot, OTAs misconfigured, housekeeping run by feel,
              guest communications written in haste.
            </p>
            <p>
              The practice is led by Aaron — an operator with hands-on
              experience running resort, hotel and apartment operations in New
              Zealand and Australia. Black Rock brings that operator-grade
              discipline to motels, hotels, hostels, Airbnb operators,
              investment property owners, holiday home managers and boutique
              stays across the Bay of Plenty and New Zealand.
            </p>
            <p className="text-white/90 font-light italic font-serif text-xl md:text-2xl border-l-2 border-[#C2A878] pl-6 mt-10">
              &ldquo;Most operators don&apos;t have a marketing problem. They
              have a systems problem. We fix the systems — the revenue
              follows.&rdquo;
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
